let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aN7AD")).then(() => parcelRequire('b7yBW'));